import React from 'react';

import staticTemplateStyles from '@/finsight/ui/components/staticPages/StaticTemplate/staticTemplate.module.scss';

import styles from './hipaa.module.scss';

const Hipaa = () => (
  <div className={ styles.hipaaContent }>
    <h3>Overview</h3>
    <p>
      At Finsight, we understand the rigorous data privacy requirements of the healthcare and life sciences
      industries. To support these sectors, we have implemented a specialized compliance framework for the storage
      and transmission of Protected Health Information (PHI).
    </p>
    <h3>Scope of Compliance</h3>
    <p>
      Finsight's HIPAA compliance is strictly scoped to ensure the highest level of integrity and control.
      Compliance is applicable only under the following conditions:
    </p>
    <ul className={ staticTemplateStyles.bulletList }>
      <li>Product: DealVDR</li>
      <li>Transaction Type: HIPAA-Compliant</li>
    </ul>
    <p>
      HIPAA compliance is not enabled by default for Finsight products. It must be specifically configured at the
      onset of a DealVDR project to ensure all necessary administrative, physical, and technical safeguards are
      active.
    </p>
    <h3>Our HIPAA Safeguards</h3>
    <p>
      For eligible DealVDR transactions, Finsight employs a multi-layered security approach:
    </p>
    <ul className={ staticTemplateStyles.bulletList }>
      <li>
        Business Associate Agreements (BAA): Finsight will execute a BAA with covered entities and business
        associates to formally clarify responsibilities regarding PHI.
      </li>
      <li>
        Data Encryption: All PHI is encrypted at rest using AES-256 and in transit via TLS 1.2 or higher.
      </li>
      <li>
        Access Control & Auditing: Granular permission settings and immutable audit logs ensure that only
        authorized personnel can access sensitive health data, with every action fully tracked.
      </li>
      <li>
        Infrastructure Security: Data is hosted in SOC 2 Type II and HIPAA-compliant data centers with 24/7
        monitoring and strict physical access controls.
      </li>
    </ul>
    <h3>Getting Started</h3>
    <p>
      If your transaction involves the exchange of Protected Health Information, please contact your Finsight
      representative to ensure your DealVDR environment is provisioned correctly for HIPAA compliance.
    </p>
    <p>
      If you have any questions or would like additional information, please reach out to{ ' ' }
      <a href="mailto:security@finsight.com">security@finsight.com</a> with any questions.
    </p>
    <p>Last Updated: April 25, 2026</p>
  </div>
);

export default Hipaa;
